import { createApp } from 'vue'
import App from '@/web/index.vue'
import guivue from '@/gui/vue/guivue.js';
import { createRouter, createWebHashHistory } from 'vue-router'




const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: () => import('@/web/home.vue')  //首页
        }, {
            path: '/download',
            component: () => import('@/web/download.vue')  //下载
        }, {
            path: '/dynamic',
            component: () => import('@/web/dynamic.vue')  //动态
        }, {
            path: '/join',
            component: () => import('@/web/join.vue')  //加入我们
        }, {
            path: '/company',
            component: () => import('@/web/company.vue')  //公司介绍
        }, {
            path: '/help',
            component: () => import('@/web/help.vue')  //帮助中心
        }, {
            path: '/connect',
            component: () => import('@/web/connect.vue')  //联系我们
        }
    ]
})


const app = createApp(App)
app.use(router)
app.config.globalProperties.guivue = guivue
app.mount('#app')